import MainComponent from './components/Main'
import 'render-colors'

function Main() {
  return (
    <>
      <MainComponent />
    </>
  )
}

export default Main
